import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircleIcon from '@mui/icons-material/Circle';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  styled,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from '@mui/material';

import {
  GridCellCheckboxRenderer,
  GridHeaderCheckbox,
  GridRowHeightParams,
  GridRowParams,
  GridSelectionModel,
  GridToolbarExport,
  gridVisibleRowCountSelector,
  selectedIdsLookupSelector,
  useGridApiRef
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { archLevel } from 'src/data/config';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { updateUserAccess } from 'src/util/util';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { MilestoneDetailModal } from './MilestoneDetailModal';
import MilestoneGanttChart from './MilestoneGanttChart';
import './MilestoneTracking.scss';
import { useMilestoneTracking } from './useMilestoneTracking';
import { DataTable } from '@pihealth/common-ui-library';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const MilestoneTracking: React.FunctionComponent<any> = () => {
  const { selectedApp, selectedAppSection } = useSelectedAppInfo();
  const [openViewQuery, setOpenViewQuery] = useState(false);
  const { setTabVal, tabVal, tabsData } = useTab();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const [value, setValue] = React.useState(0);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [open, setOpen] = useState(false);
  const [disableHoldBtn, setDisableHoldBtn] = useState(false);
  const [disableNABtn, setDisableNABtn] = useState(false);
  const [isGridDataLoading, setIsGridDataLoading] = useState(false);

  const [updateStatus, setUpdateStatus] = useState('');
  const { user } = useUser();
  const { mileStoneNostatusChangeMsg, mileStoneErrorstatusChangeMsg, mileStoneTrackingHelpText, nextTxt } =
    useFieldTranslation();
  const dispatch = useAppDispatch();

  const {
    milestoneData,
    milestoneDataError,
    getMilestoneQueryData,
    milestoneDataLoading,
    updateMilestoneError,
    updateMilestoneDataStatus,
    updateMilestoneSuccess,
    activateMilestone,
    activateMilestoneSuccess,
    activateMilestoneIsError,
    activateMilestoneError
  } = useMilestoneTracking();

  const getMilestoneData = async () => {
    setIsGridDataLoading(true);
    await getMilestoneQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      tmfDocLevel: 'Site',
      application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
      application_section: selectedAppSection
    });
    setIsGridDataLoading(false);
  };
  const getSelectedRow = (id: any) => {
    setSelectedRowId(id);
    setOpen(true);
  };
  const handleNextbtn = (_: any) => {
    setTabVal(tabVal + 1);
  };

  const handleChange = (_event: any, newValue: any) => {
    /**
     * Added if condition when chnage the tabs to set the actuall filter value.
     */
    if (newValue == 0) {
      setSelectionModel([]);
      prevSelectionModel.current = [];
      getMilestoneData();
    }
    /**
     * End
     */
    setValue(newValue);
  };

  const [pageSize, setPageSize] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [selectionModel, setSelectionModel] = React.useState<GridSelectionModel>([]);
  const prevSelectionModel = React.useRef<GridSelectionModel>(selectionModel);

  const handleClose = () => {
    setOpen(false);
  };
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [gridRows, setGridRows] = useState<any>([]);
  const [selectedMilestoneData, setSelectedMilestoneData] = useState<any>({});
  const [gridRowsCount, setGridRowsCount] = React.useState(0);
  const [activemilestoneCount, setActiveMilestoneCount] = useState<number>();
  const {
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    setReport_id: setReportId,
    queryType,
    setQueryType
  } = useQueryMenus('MILESTONE TRACKING');
  /**
   * Filter row count showing funtionality
   */
  const apiRef = useGridApiRef();
  // Only render when the visible columns changes Start
  React.useEffect(() => {
    if (apiRef.current !== null) {
      apiRef.current.subscribeEvent('stateChange', () => {
        const count = gridVisibleRowCountSelector(apiRef.current.state);
        setGridRowsCount(count);
      });
    }
  }, [apiRef, gridRows]);

  /**
   * Filter row count showing funtionality End
   */

  useEffect(() => {
    if (milestoneData) {
      const updated: any = milestoneData.map((item: any) => {
        return {
          id: item.milestone_id,
          ...item,
          document_progress: `${item.doc_approved_count}/${item.doc_total_count} Approved`,
          Activated: item.is_activated ? 'Yes' : 'No'
        };
      });
      setGridRows(updated);
      setGridRowsCount(updated.length);
    }
    setIsGridDataLoading(false);
  }, [milestoneData, raisedQueries]);

  useEffect(() => {
    if (milestoneDataError) {
      setGridRows([]);
      updateUserAccess(milestoneDataError, dispatch);
    }
    setIsGridDataLoading(false);
  }, [milestoneDataError]);

  const addSelectedMilestoneRowData = async (selectedMilestoneRows: any[]) => {
    let statusMilestoneData: any[];
    const isError = false;
    const prepareMilestoneData = selectedMilestoneRows.map(rowId => {
      return gridRows.find((item: any) => item.milestone_id == rowId);
    });

    if (updateStatus === 'Not applicable') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkNotApplicableCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      if (statusMilestoneData.length > 0) {
        setUpdateMilestoneData(statusMilestoneData, isError, 'Milestone updated successfully');
      } else {
        dispatch(setMessage({ msgDetails: mileStoneNostatusChangeMsg, severity: 'error' }));
        setUpdateStatus('');
      }
    } else if (updateStatus === 'On hold') {
      statusMilestoneData = prepareMilestoneData
        .filter((milestone: any) => {
          return checkOnHoldCriteria(milestone);
        })
        .map((milestone: any) => {
          return milestone;
        });
      if (statusMilestoneData.length > 0) {
        setUpdateMilestoneData(statusMilestoneData, isError, 'Milestone updated successfully');
      } else {
        dispatch(setMessage({ msgDetails: mileStoneNostatusChangeMsg, severity: 'error' }));
        setUpdateStatus('');
      }
    }
  };

  const setUpdateMilestoneData = (milestones: any[], isError: boolean, alretMessage: string) => {
    if (isError) {
      dispatch(setMessage({ msgDetails: alretMessage, severity: 'error' }));
    } else {
      setSelectedMilestoneData({
        milestone_ids: milestones.map((item: any) => item.milestone_id),
        milestone_status: updateStatus,
        is_activated: false,
        updated_by: user
      });
    }
  };

  const checkActiveCriteria = (milestone: any): any => {
    if (!milestone.is_activated && milestone.milestone_status == 'Not set') {
      return true;
    } else {
      return false;
    }
  };

  const checkNotApplicableCriteria = (milestone: any): any => {
    if (milestone.milestone_status === 'Not set' || milestone.milestone_status == 'Planned') {
      return true;
    } else {
      return false;
    }
  };

  const checkOnHoldCriteria = (milestone: any): any => {
    if (milestone.milestone_status === 'In progress') {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (updateStatus !== '') {
      addSelectedMilestoneRowData(getSelctionAfterFilter());
    }
  }, [updateStatus]);

  useEffect(() => {
    if (Object.keys(selectedMilestoneData).length !== 0) {
      updateMilestoneDataStatus({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
        data: selectedMilestoneData,
        application_section: selectedAppSection
      });
    }
  }, [selectedMilestoneData]);

  useEffect(() => {
    if (updateMilestoneSuccess) {
      getMilestoneData();
      selectionModel.map((item: any) => {
        gridRows.map((rowData: any) => {
          if (rowData.milestone_id === item) {
            if (selectedMilestoneData.milestone_ids.includes(rowData.milestone_id)) {
              const rowIndex = gridRows.findIndex((obj: any) => obj.milestone_id === item);
              gridRows[rowIndex].milestone_status = updateStatus;
              gridRows[rowIndex].updated_by = user;
            }
          }
        });
      });
      setUpdateStatus('');
    }
  }, [updateMilestoneSuccess]);

  useEffect(() => {
    if (updateMilestoneError) {
      const updateMilestoneErrorData: any = updateMilestoneError;
      dispatch(
        setMessage({
          msgDetails: `${updateMilestoneErrorData?.status}: ${
            updateMilestoneErrorData?.data?.detail || mileStoneErrorstatusChangeMsg
          }`,
          severity: 'error'
        })
      );
      setUpdateStatus('');
    }
  }, [updateMilestoneError]);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!active) {
        return;
      }
      setTimeout(() => {
        setSelectionModel(prevSelectionModel.current);
      });
    })();
    return () => {
      active = false;
    };
  }, [page, pageSize, gridRows]);

  useEffect(() => {
    getMilestoneData();
  }, [selectedSite, open]);
  const formatDate = (params: any) => {
    return preferedDateFormat(params.value);
  };
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('activate_site_milestone');

  const viewNotes = (row: any) => {
    setReportId(row.milestone_id);
    const newObj = {
      ...checkListQueries.mileStone_report,
      id: row.milestone_id,
      report_id: row.milestone_id,
      section_key: 'MileStone',
      report_field_value: row.minor_milestone,
      report_field_name: row.minor_milestone,
      report_field_label: row.minor_milestone,
      section_field_names: [],
      is_all_field_queries: true
    };
    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('Field');
  };

  const columns = [
    {
      field: '__check__',
      type: 'checkboxSelection',
      width: 64,
      resizable: false,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      disableReorder: true,
      disableExport: true,
      headerAlign: 'left',
      valueGetter: (params: any) => {
        const selectionLookup = selectedIdsLookupSelector(params.api.state);
        return selectionLookup[params.id] !== undefined;
      },
      renderHeader: (params: any) => (
        <>
          <GridHeaderCheckbox {...params} />
          &nbsp;All
        </>
      ),
      renderCell: (params: any) => <GridCellCheckboxRenderer {...params} />
    },
    {
      field: 'Activated',
      headerName: '',
      width: 64,
      sortable: false,
      type: 'singleSelect',
      valueOptions: ['Yes', 'No'],
      renderCell: (params: any) => (
        <Tooltip
          title={params.row?.Activated == 'Yes' ? 'Active' : 'Inactive'}
          placement="top"
          className="smallfontTooltip"
        >
          <IconButton>
            <CircleIcon color={params.row?.Activated == 'Yes' ? 'success' : 'disabled'} fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    },
    {
      field: 'major_milestone',
      headerName: mileStoneTrackingHelpText.majorMilestone,
      width: 180,
      minWidth: 140,
    },
    {
      field: 'minor_milestone',
      headerName: mileStoneTrackingHelpText.minorMilestone,
      width: 220,
      minWidth: 180,
      renderCell: (params: any) =>
        checkPermission('view_milstone_details') ? (
          <Link onClick={() => getSelectedRow(params.row.milestone_id)}>{params.value?.toString()}</Link>
        ) : (
          params.value?.toString()
        )
    },
    {
      field: 'milestone_status',
      headerName: mileStoneTrackingHelpText.milestoneStatus,
      width: 130,
      minWidth: 100,
      type: 'singleSelect',
      valueOptions: ['Not applicable', 'On hold', 'Not set', 'Planned', 'In progress', 'Completed', 'Overdue']
    },
    {
      field: 'document_progress',
      headerName: mileStoneTrackingHelpText.documentProgress,
      width: 130,
      minWidth: 100,
    },
    {
      field: 'start_date_planned_baseline',
      headerName: mileStoneTrackingHelpText.startDatePlannedBaseline,
      width: 150,
      minWidth: 130,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'start_date_adjusted',
      headerName: mileStoneTrackingHelpText.startDateAdjusted,
      width: 150,
      minWidth: 120,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'start_date_actual',
      headerName: mileStoneTrackingHelpText.startDateActual,
      width: 150,
      minWidth: 120,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'end_date_planned_baseline',
      headerName: mileStoneTrackingHelpText.endDatePlannedBaseline,
      width: 150,
      minWidth: 140,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'end_date_adjusted',
      headerName: mileStoneTrackingHelpText.endDateAdjusted,
      width: 150,
      minWidth: 110,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'end_date_actual',
      headerName: mileStoneTrackingHelpText.endDateActual,
      width: 150,
      minWidth: 120,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'date_last_update',
      headerName: mileStoneTrackingHelpText.dateLastUpdated,
      width: 150,
      minWidth: 110,
      type: 'date',
      valueFormatter: formatDate
    },
    {
      field: 'milestone_level',
      headerName: mileStoneTrackingHelpText.milestoneLevel,
      width: 150,
      minWidth: 120,
    },
    {
      field: 'priority',
      headerName: mileStoneTrackingHelpText.priority,
      width: 100,
      minWidth: 80,
    },
    {
      field: 'updated_by',
      headerName: mileStoneTrackingHelpText.updatedBy,
      width: 150,
      minWidth: 120,
    },
    {
      field: 'assigned_to',
      headerName: mileStoneTrackingHelpText.assignedTo,
      width: 150,
      minWidth: 120,
      renderCell: (params: any) => {
        return (
          <Tooltip title={params.row.assigned_to?.length > 18 ? params.row.assigned_to : ''} placement="top">
            <Box sx={{ whiteSpace: 'nowrap !important', textOverflow: 'ellipsis', overflow: 'hidden' }}>
              {params.row.assigned_to}
            </Box>
          </Tooltip>
        );
      }
    },
    {
      field: 'pi_name',
      headerName: mileStoneTrackingHelpText.pIName,
      width: 150,
      minWidth: 120,
    },
    {
      field: 'help',
      headerName: '',
      width: 60,
      hideable: false,
      filterable: false,
      disableExport: true,
      sortable: false,
      disableColumnSelector: true,

      renderCell: (params: any) => (
        <>
          <Tooltip title="Query" placement="top" arrow>
            <IconButton
              className={`grey-btn${raisedQueries?.includes(params.row.minor_milestone) ? ' danger-link' : ''}`} //VIEW_STARTUP_QUERIES_MILESTONE
              onClick={() => viewNotes(params.row)}
              disabled={
                selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
                  ? !checkPermission('view_quires_milestone')
                  : !checkPermission('view_startup_quires_milestone')
              }
              title="Query"
              sx={{ mx: 'auto' }}
            >
              <LiveHelpOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];
  const [paginationVal, setPaginationVal] = useState(true);
  const getSelctionAfterFilter = () => {
    try {
      if (Object.entries(apiRef.current.state.filter.filteredRowsLookup).length === 0) {
        return selectionModel;
      } else {
        const filtered = Object.entries(apiRef.current.state.filter.filteredRowsLookup).filter(a => a[1]);
        const filteredIds = filtered.map(a => a[0]);
        const filterdSelectionRows = selectionModel.filter(item => filteredIds.includes(item.toString()));
        return filterdSelectionRows;
      }
    } catch (e) {
      return selectionModel;
    }
  };
  const getSelctionCountAfterFilter = () => getSelctionAfterFilter().length;

  const currentDate = new Date();
  const [viewModeType, setviewModeType] = useState<any>('All');
  const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth() + 1);
  const [currentMonthDate, setCurrentMonthDate] = useState(
    `${currentYear}-${currentMonth}-${new Date(currentYear, currentMonth, 0).getDate()}`
  );

  const onClickDecrease = () => {
    if (viewModeType == 'Month') {
      setCurrentYear(currentYear - 1);
    }
    if (currentMonth > 1 && viewModeType == 'Day') {
      setCurrentMonthDate(
        `${currentDate.getFullYear()}-${currentMonth - 1}-${new Date(currentYear - 1, currentMonth - 1, 0).getDate()}`
      );
      setCurrentMonth(currentMonth - 1);
    }
  };
  const onClickIncrease = () => {
    if (viewModeType == 'Month') {
      setCurrentYear(currentYear + 1);
    }
    if (currentMonth < 12 && viewModeType == 'Day') {
      setCurrentMonthDate(
        `${currentDate.getFullYear()}-${currentMonth + 1}-${new Date(currentYear + 1, currentMonth + 1, 0).getDate()}`
      );
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleViewModeChange = (_: React.MouseEvent<HTMLElement>, viewMode: any) => {
    setviewModeType(null);
    setviewModeType(viewMode);
    setCurrentMonthDate(
      `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${new Date(
        currentDate.getMonth() + 1,
        currentDate.getFullYear(),
        0
      ).getDate()}`
    );
    setCurrentMonth(currentDate.getMonth() + 1);
    setCurrentYear(currentDate.getFullYear());
  };
  const isStatusButtonDisabled = () => {
    return selectionModel.length === 0
      ? true
      : getSelctionCountAfterFilter() === 0
      ? true
      : isSelectedMilestoneExistsWithStatus('Not set');
  };
  const isSelectedMilestoneExistsWithStatus = (checkStatus: string) => {
    const selectedMilestoneRows: any[] = getSelctionAfterFilter();
    if (checkPermission('activate_site_milestone')) {
      if (selectedMilestoneRows.length > 0) {
        const prepareMilestoneData = selectedMilestoneRows.map(rowId => {
          return gridRows.find((item: any) => item.milestone_id == rowId);
        });
        if (prepareMilestoneData.length > 0) {
          return (
            prepareMilestoneData.find(
              (milestone: any) => !milestone.is_activated && milestone.milestone_status == checkStatus
            ) === undefined
          );
        }
      }
    } else {
      return true;
    }
  };
  const getUpdatedStatus = (status: string) => {
    setUpdateStatus(status);
  };

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const [auditUsersList, setAuditUsersList] = useState([]);
  const [
    getAssignees,
    { isLoading: isAssingeeLoading, data: assignees, isError: isAssingeeError, isSuccess: isAssingeeSuccess }
  ] = useGetAssigneesMutation();

  const setUpdateActiveMilestoneData = async () => {
    const selectedMilestoneRows = getSelctionAfterFilter();
    const prepareMilestoneData = selectedMilestoneRows.map(rowId => {
      return gridRows.find((item: any) => item.milestone_id == rowId);
    });
    const statusMilestoneData = prepareMilestoneData
      .filter((milestone: any) => {
        return checkActiveCriteria(milestone);
      })
      .map((milestone: any) => {
        return milestone;
      });

    if (statusMilestoneData.length > 0) {
      setActiveMilestoneCount(statusMilestoneData.length);
      const selectedAcitveMilestoneData = {
        milestone_ids: statusMilestoneData.map((item: any) => item.milestone_id),
        is_activated: true,
        updated_by: user
      };
      await activateMilestone({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME,
        data: selectedAcitveMilestoneData,
        application_section: selectedAppSection
      });
    }
  };

  useEffect(() => {
    if (activateMilestoneSuccess) {
      dispatch(
        setMessage({ msgDetails: `${activemilestoneCount} Milestones activated successfully`, severity: 'success' })
      );
      getMilestoneData();
    }
  }, [activateMilestoneSuccess]);
  useEffect(() => {
    if (activateMilestoneIsError) {
      const dataErorr: any = activateMilestoneError;
      if (dataErorr?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${dataErorr?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (dataErorr?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (dataErorr?.status !== 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error Data',
            severity: 'error'
          })
        );
      }
    }
  }, [activateMilestoneIsError]);

  useEffect(() => {
    if (!isAssingeeLoading && isAssingeeError) {
      dispatch(setMessage({ msgDetails: 'Unable to get assignees', severity: 'error' }));
    } else if (!isAssingeeLoading && isAssingeeSuccess && assignees) {
      const assignList: any = assignees.map((item: any) => `${item.first_name} ${item.last_name}`);
      setAuditUsersList(assignList);
    }
  }, [isAssingeeLoading, isAssingeeSuccess, assignees, isAssingeeError]);

  useEffect(() => {
    if (selectedRowId !== null) {
      getAssignees({
        client_name: 'ctms-ui',
        data: ['UPDATE_CRA_MILESTONES', 'UPDATE_PIL_MILESTONES', 'UPDATE_SITE_MILESTONES']
      });
    }
  }, [selectedRowId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setQueryType('Field');
    setQueryKeys(checkListQueries.mileStone_report);
  }, []);

  useEffect(() => {
    if (selectionModel.length === 1) {
      const status = gridRows.filter((item: any) => item.milestone_id === selectionModel[0]);
      status[0].is_activated && (status[0].milestone_status === 'Not set' || status[0].milestone_status === 'Planned')
        ? setDisableNABtn(false)
        : setDisableNABtn(true);
      status[0].is_activated && status[0].milestone_status === 'In progress'
        ? setDisableHoldBtn(false)
        : setDisableHoldBtn(true);
    }
  }, [selectionModel]);
  const dataTableProps = {
    apiRef,
    onRowsSelection: (newSelection: any) => setSelectionModel(newSelection),
    getRowHeight: ({ id, densityFactor }: GridRowHeightParams) => {
      if ((id as number) % 2 === 0) {
        return 100 * densityFactor;
      }
      return null;
    },
    isRowSelectable: (params: GridRowParams) =>
      params.row.is_update_eligible || checkPermission('activate_site_milestone'),
    setPaginationValue: (hideColumsArr: any) => {
      if (hideColumsArr.includes(true)) {
        setPaginationVal(true);
      } else {
        setPaginationVal(false);
      }
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        disabled={!checkPermission('print_milestones') && !checkPermission('export_milestones') ? true : false}
        printOptions={{ disableToolbarButton: !checkPermission('print_milestones') ? true : false }}
        csvOptions={{
          fileName: `Milestone Tracking ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`,
          disableToolbarButton: !checkPermission('export_milestones') ? true : false
        }}
      />
    );
  };
  return (
    <div className="milestone-page">
      <Grid container spacing={0} mt={-2}>
        <Grid item md={12}>
          <Box sx={{ width: '100%' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label={mileStoneTrackingHelpText.milestonePlannerView} {...a11yProps(0)} />
              <Tab label={mileStoneTrackingHelpText.ganttView} {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={value} index={0} className="milestone-view-block">
              <Grid container>
                <Grid md={12}>
                  <div className="datGridWrap milestone">
                    <DataTable
                      height={'61vh'}
                      dataTableProps={dataTableProps}
                      pinnedColumns={{ right: ['help'] }}
                      className="milestone-datagrid"
                      rows={gridRows}
                      hasDefinedColumns
                      columns={columns}
                      checkboxSelection
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      rowCount={gridRowsCount}
                      onPageChange={(newPage: any) => {
                        prevSelectionModel.current = selectionModel;
                        setPage(newPage);
                      }}
                      pagination={paginationVal}
                      onRowsSelection={(newSelection: any) => setSelectionModel(newSelection)}
                      selectionModel={selectionModel}
                      loading={isGridDataLoading || milestoneDataLoading}
                      hasDefinedDataGridToolbarExport
                      definedGridToolbarExport={definedCustomDatGridExport}
                    />
                  </div>
                </Grid>
              </Grid>

              <Grid container className="button-section">
                {isDisable ? (
                  <Grid md={12}>
                    <p>{selectionModel.length === 0 ? 'No' : getSelctionCountAfterFilter()} Milestones Selected</p>
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>

              <Grid container spacing={2} className="button-section" mb={-2}>
                <Grid item md={10}>
                  <Item>
                    <Stack spacing={2} direction="row">
                      <Button
                        variant="contained"
                        disabled={isStatusButtonDisabled()}
                        onClick={() => setUpdateActiveMilestoneData()}
                      >
                        Activate
                      </Button>
                      <Button
                        variant="contained"
                        disabled={selectionModel.length !== 1 || disableHoldBtn}
                        onClick={() => getUpdatedStatus('On hold')}
                      >
                        SET ON HOLD
                      </Button>
                      <Button
                        variant="contained"
                        disabled={selectionModel.length !== 1 || disableNABtn}
                        onClick={() => getUpdatedStatus('Not applicable')}
                      >
                        NOT APPLICABLE
                      </Button>
                    </Stack>
                  </Item>
                </Grid>

                {/* </PermissionWrapper> */}
                {currentTabinfo[0]?.NextButton && (
                  <Grid item md={2} display="flex" justifyContent="flex-end">
                    <Item>
                      <Stack spacing={2} direction="row">
                        <Button onClick={handleNextbtn} variant="contained">
                          {nextTxt}
                        </Button>
                      </Stack>
                    </Item>
                  </Grid>
                )}
              </Grid>
              <div>
                {selectedRowId !== null && (
                  <PopupComponent
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    maxWidth="lg"
                    className="milestone-modal"
                  >
                    <MilestoneDetailModal
                      getData={getMilestoneData}
                      handleClose={handleClose}
                      gridRows={gridRows}
                      selectedRowId={selectedRowId}
                      auditUsersList={auditUsersList}
                      isGridDataLoading={isGridDataLoading}
                      openDetailsModal={open}
                    />
                  </PopupComponent>
                )}
              </div>
              <div>
                {openViewQuery && (
                  <ViewQuery
                    totalFieldQueries={totalFieldQueries}
                    totalSectionQueries={totalSectionQueries}
                    open={openViewQuery}
                    setOpen={setOpenViewQuery}
                    queryKeys={queryKeys}
                    queryType={queryType}
                    fieldQueries={fieldQueries}
                    getSivReportQueries={getSivReportQueries}
                    setQueryType={setQueryType}
                    report_id={selectedMilestoneData.milestone_id}
                    isSQSivQueries={false}
                  />
                )}
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} className="milestone-view-block">
              <Grid container>
                <Grid md={12}>
                  <div className="gannt-filter-section">
                    {viewModeType != 'All' && (
                      <div className="year-section">
                        <Button onClick={() => onClickDecrease()}>
                          <ArrowBackIosIcon />
                        </Button>
                        {viewModeType == 'Day' ? monthNames[currentMonth - 1] : currentYear}
                        <Button onClick={() => onClickIncrease()}>
                          <ArrowForwardIosIcon />
                        </Button>
                      </div>
                    )}
                    <ToggleButtonGroup
                      sx={{ display: 'flex', justifyContent: 'flex-end' }}
                      size="small"
                      color="info"
                      value={viewModeType}
                      exclusive
                      onChange={handleViewModeChange}
                      className="year-month-block"
                    >
                      <ToggleButton value="All">All</ToggleButton>
                      <ToggleButton value="Month">Year</ToggleButton>
                      <ToggleButton value="Day">Month</ToggleButton>
                    </ToggleButtonGroup>
                  </div>
                  <div style={{ minHeight: 400, width: '100%' }}>
                    <MilestoneGanttChart
                      currentMonth={currentMonth}
                      currentYear={currentYear}
                      viewModeType={viewModeType}
                      currentMonthDate={currentMonthDate}
                    />
                  </div>
                </Grid>
              </Grid>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default MilestoneTracking;
